import React from "react";
import { connect } from 'react-redux';
import AgentsTableForSupervisor from '../../supervisor/agents/AgentsTableForSupervisor'

class TeamAgentsTableForManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        const
            {
                onClose
            } = this.props;

        if (this.wrapperRef) {
            if (!this.wrapperRef.current.contains(event.target)) {
                onClose();
            }
        }
    }

    render() {
        const {
            selectedTeam,
            onSelectAgent,
        } = this.props;

        return (<div className="modal displayBlock" >
            <div className="modal-content" ref={this.wrapperRef}>
                <AgentsTableForSupervisor
                    hideTitle={true}
                    teamsCalibrationStatsForOwnTeam={selectedTeam}
                    onSelectAgent={(userId) => onSelectAgent(userId)} />
            </div>
        </div>);
    };
}

const select = state => ({ ...state.CalibrationV3Screen });

export default connect(select)(TeamAgentsTableForManager);

